import { type } from 'arktype'

export const allProducts = [
  'rcph',
  'muta',
  'rcda',
  'es-rcph',
  'rcpa',
  'rcpaxa',
  'fr-prel',
  'fr-rcpw',
  'nl-rcph',
  'mrph',
  'mrpw',
  'mrpa',
  'es-mrpw',
  'fr-rccw',
  'nl-aovql',
] as const
export const productSchema = type('===', ...allProducts)
export type Product = typeof productSchema.infer
